<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="default"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/sampling/${inputs.id}`
            : '/accreditations/sampling'
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>PRODUCTO O MATERIAL A MUESTREAR</label>
              <app-input
                type="textarea"
                v-model="inputs.product"
                placeholder="Ingrese el producto o material a muestrear"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label
                >PROCEDIMIENTO DE MUESTREO (Procedimiento normalizado y
                procedimiento interno, si aplica)</label
              >
              <app-input
                type="textarea"
                v-model="inputs.process"
                :required="true"
                placeholder="Ingrese el procedimiento de muestreo"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label
                >MÉTODOS DE ENSAYO A LOS QUE APLICA (Procedimiento interno y/o
                método de referencia con su revisión/edición)</label
              >
              <app-input
                type="textarea"
                v-model="inputs.method"
                placeholder="Ingrese los métodos de ensayo a los que aplica"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    selectedUrl: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      disabledSubmit: false,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
